<script>
  import { isFetching } from './stores/isFetching';
  import { fade } from 'svelte/transition';
</script>

{#if $isFetching}
  <div class="spinner-fullsize" transition:fade />
{/if}
